import { createActions, createState, createReducer } from 'reduxsauce-crud'
import { clone, find, findIndex, propEq, merge } from 'ramda'

const d = { deep: true }

export const ChildrenRedux = createActions(
  {
    setActiveChildId: ['childId'],
    checkInRequest: ['childId', 'data'],
    checkInSuccess: ['response'],
    checkInError: ['err'],
    authorizeSuccess: ['id', 'data'],
    unauthorizeSuccess: ['id', 'data'],
    activateSuccess: ['id', 'data'],
    deleteCards: ['id', 'data'],
    updateCards: ['id', 'data'],
    getProfileRequest: ['childId'],
    getProfileSuccess: ['profile'],
    getProfileError: ['error'],
    getActivitiesRequest: ['studentId', 'query'],
    getActivitiesSuccess: ['results'],
    getActivitiesError: ['error'],
    updateStudentRequest: ['activeStudentId', 'profile', 'timestamp'],
    updateStudentSuccess: ['profile'],
    updateStudentFailed: ['error'],
  },
  {
    prefix: 'PARENT_PLATFORM_CHILDREN_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = ChildrenRedux
export const ChildrenTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  activeChildId: null,
  checkIn: {
    fetching: false,
    result: null,
    error: null,
  },
}, {
  get: true,
})

const setActiveChildId = (state, { childId }) => state.merge({
  activeChildId: childId,
}, d)

const checkInRequest = state => state.merge({
  checkIn: {
    fetching: true,
  },
}, d)
const checkInSuccess = (state, { response }) => state.merge({
  checkIn: {
    fetching: false,
    result: response,
    error: null,
  },
}, d)
const checkInError = (state, { err }) => state.merge({
  checkIn: {
    fetching: false,
    result: null,
    error: err,
  },
}, d)

const getProfileRequest = state => state.merge({ get: { fetching: true, error: null } }, d)

const getProfileSuccess = (state, { profile }) => {
  const newChildren = clone(state.get.results)
  const activeChildIndex = findIndex(propEq('id', state.activeChildId))(newChildren)
  newChildren[activeChildIndex] = profile
  return state.merge({ get: { fetching: false, results: newChildren, error: null } }, d)
}

const getProfileError = (state, { error }) => state.merge({ get: { fetching: false, error } }, d)

const getActivitiesRequest = state => state.merge({ get: { fetching: true, error: null } }, d)

const getActivitiesSuccess = (state, { results }) =>
  state.merge({ get: { fetching: false, results, error: null } }, d)

const getActivitiesError = (state, { error }) => state.merge({ get: { fetching: false, error } }, d)

const authorizeSuccess = (state, { id, data }) => {
  const newChildren = clone(state.get.results)
  const activeChildIndex = findIndex(propEq('id', state.activeChildId))(newChildren)
  const newCards = clone(newChildren[activeChildIndex].credit_cards)
  const cardIndex = findIndex(propEq('id', id))(newCards.unauthorized)
  const card = newCards.unauthorized[cardIndex]
  const newInfo = { authorized_at: data.authorized_at }
  const cardUpdated = merge(card, newInfo)
  newCards.authorized.push(cardUpdated)
  newCards.unauthorized.splice(cardIndex, 1)
  newChildren[activeChildIndex].credit_cards = newCards
  return state.merge({ get: { fetching: false, results: newChildren, error: null } }, d)
}

const activateSuccess = (state, { id }) => {
  const newChildren = clone(state.get.results)
  const activeChildIndex = findIndex(propEq('id', state.activeChildId))(newChildren)
  const newCards = clone(newChildren[activeChildIndex].credit_cards)
  const cardIndex = findIndex(propEq('id', id))(newCards.authorized)
  const card = newCards.authorized[cardIndex]
  const newInfo = { is_default: true }
  const cardUpdated = merge(card, newInfo)
  newCards.authorized[cardIndex] = cardUpdated

  const oldCardIndex = findIndex(propEq('is_default', true))(newCards.authorized)
  const oldCard = newCards.authorized[oldCardIndex]
  const oldInfo = { is_default: false }
  const oldCardUpdated = merge(oldCard, oldInfo)
  newCards.authorized[oldCardIndex] = oldCardUpdated

  newChildren[activeChildIndex].credit_cards = newCards
  return state.merge({ get: { fetching: false, results: newChildren, error: null } }, d)
}

const unauthorizeSuccess = (state, { id, data }) => {
  const newChildren = clone(state.get.results)
  const activeChildIndex = findIndex(propEq('id', state.activeChildId))(newChildren)
  const newCards = clone(newChildren[activeChildIndex].credit_cards)
  const cardIndex = findIndex(propEq('id', id))(newCards.authorized)
  const cardUpdated = data
  newCards.unauthorized.push(cardUpdated)
  newCards.authorized.splice(cardIndex, 1)
  newChildren[activeChildIndex].credit_cards = newCards
  return state.merge({ get: { fetching: false, results: newChildren, error: null } }, d)
}

const updateCards = (state, { id, data }) => {
  let newCards = null
  const newChildren = clone(state.get.results)
  const activeChildIndex = findIndex(propEq('id', id))(newChildren)
  if (newChildren[activeChildIndex].credit_cards) {
    newCards = clone(newChildren[activeChildIndex].credit_cards)
  } else {
    newCards = clone(newChildren[activeChildIndex])
    newCards.credit_cards = []
  }

  if (!newCards.authorized) {
    newCards.authorized = []
  }
  newCards.authorized.push(data)
  newChildren[activeChildIndex].credit_cards = newCards
  return state.merge({ get: { fetching: false, results: newChildren, error: null } }, d)
}

const deleteCards = (state, { id }) => {
  const newChildren = clone(state.get.results)
  const activeChildIndex = findIndex(propEq('id', state.activeChildId))(newChildren)
  const newCards = clone(newChildren[activeChildIndex].credit_cards)
  const cardIndex = findIndex(propEq('id', id))(newCards.unauthorized)
  newCards.unauthorized.splice(cardIndex, 1)
  newChildren[activeChildIndex].credit_cards = newCards
  return state.merge({ get: { fetching: false, results: newChildren, error: null } }, d)
}
const updateStudentRequest = state => state.merge({ get: { fetching: true, error: null } }, d)

const updateStudentSuccess = (state, { profile }) => {
  if (!profile.id) {
    return state
  }
  const newChildren = clone(state.get.results)
  const activeChildIndex = findIndex(propEq('id', state.activeChildId))(newChildren)
  if(activeChildIndex > -1)[
    newChildren[activeChildIndex] = profile
  ]
  
    return state.merge({ get: { fetching: false, error:null,  results: newChildren } }, d)
  }
  
  const updateStudentFailed = (state, { error }) => state.merge({ get: { fetching: false, error } }, d)
  

export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.setActiveChildId]: setActiveChildId,
    [Types.checkInRequest]: checkInRequest,
    [Types.checkInSuccess]: checkInSuccess,
    [Types.checkInError]: checkInError,
    [Types.getProfileRequest]: getProfileRequest,
    [Types.getProfileSuccess]: getProfileSuccess,
    [Types.getProfileError]: getProfileError,
    [Types.getActivitiesRequest]: getActivitiesRequest,
    [Types.getActivitiesSuccess]: getActivitiesSuccess,
    [Types.getActivitiesError]: getActivitiesError,
    [Types.authorizeSuccess]: authorizeSuccess,
    [Types.unauthorizeSuccess]: unauthorizeSuccess,
    [Types.activateSuccess]: activateSuccess,
    [Types.updateCards]: updateCards,
    [Types.deleteCards]: deleteCards,
    [Types.updateStudentRequest]: updateStudentRequest,
    [Types.updateStudentSuccess]: updateStudentSuccess,
    [Types.updateStudentFailed]: updateStudentFailed,
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)

/**
 * Search the redux store for the active child belonging to the active parent,
 * and return the student object.
 *
 * @param  {object} state  The Redux state
 * @return {object}
 */
const activeChild = ({ parent_platform_children }) => {
  const { activeChildId } = parent_platform_children
  const children = parent_platform_children.get.results || []

  if (children.length <= 0) return null

  return {
    activeChildIndex: findIndex(propEq('id', activeChildId))(children),
    student: find(propEq('id', activeChildId))(children),
  }
}

export const Selectors = {
  activeChild,
}



// WEBPACK FOOTER //
// ./src/Data/Redux/ParentPlatform/ChildrenRedux.js